export default {
  admin_add_cad_user_swal_required_title: "Required fields",
  admin_add_cad_user_swal_required_text_name_email: "Fill in Name and E-mail to continue.",
  admin_add_cad_user_swal_required_text_phone: "Fill in the Phone to continue.",
  admin_add_cad_user_swal_required_cnpj_title: "CNPJ required",
  admin_add_cad_user_swal_required_cnpj_text: "To create a client it is necessary to provide the CNPJ.",
  admin_add_cad_user_swal_success_client_title: "Client created!",
  admin_add_cad_user_swal_success_client_text: "The client was successfully registered",
  admin_add_cad_user_swal_success_employee_title: "Employee registered!",
  admin_add_cad_user_swal_success_employee_text: "The employee was successfully registered.",
  admin_add_cad_user_swal_error_title: "Error",
  admin_add_cad_user_swal_error_text: "Could not create user. Try again.",
  admin_add_cad_user_title: "Create user",
  admin_add_cad_user_label_name: "Name:",
  admin_add_cad_user_placeholder_name: "Maria Silva",
  admin_add_cad_user_label_email: "E-mail:",
  admin_add_cad_user_placeholder_email: "email@company.com",
  admin_add_cad_user_label_profile: "Profile:",
  admin_add_cad_user_option_client: "Client",
  admin_add_cad_user_option_technician: "Technician",
  admin_add_cad_user_option_admin: "Commercial",
  admin_add_cad_user_label_company: "Company name:",
  admin_add_cad_user_placeholder_company: "Company XYZ",
  admin_add_cad_user_label_cnpj: "CNPJ:",
  admin_add_cad_user_placeholder_cnpj: "00.000.000/0000-00",
  admin_add_cad_user_label_phone: "Phone:",
  admin_add_cad_user_placeholder_phone: "(11) 90000-0000",
  admin_add_cad_user_btn_create: "Create",
  admin_add_cad_user_notify_text_1: "Your client will be notified via e-mail and WhatsApp with an access link.",
  admin_add_cad_user_notify_text_2: "During the trial version, any registered user will have the default password \"123456\".",
  admin_add_equip_swal_attention_title: "Attention",
  admin_add_equip_swal_remove_warning_text: "This equipment will be removed upon saving.",
  admin_add_equip_swal_error_title: "Error",
  admin_add_equip_swal_invalid_service_text: "Select a valid service.",
  admin_add_equip_swal_success_title: "Success",
  admin_add_equip_swal_save_success_text: "Equipment saved!",
  admin_add_equip_swal_save_first_text: "Save the equipment first.",
  admin_add_equip_swal_remove_photo_title: "Remove photo?",
  admin_add_equip_swal_remove_photo_success_text: "Photo removed!",
  admin_add_equip_prompt_laudo_name: "Report name:",
  admin_add_equip_swal_remove_laudo_title: "Remove report?",
  admin_add_equip_swal_remove_laudo_success_text: "Report removed.",
  admin_add_equip_label_service: "Linked service",
  admin_add_equip_label_brand: "Brand",
  admin_add_equip_label_model: "Model",
  admin_add_equip_label_series: "Series",
  admin_add_equip_label_ca: "CA",
  admin_add_equip_label_obs_tech: "Technical Observation",
  admin_add_equip_label_location: "Location",
  admin_add_equip_label_next_revision: "Next Revision",
  admin_add_equip_label_last_revision: "Last Revision",
  admin_add_equip_label_active: "Active",
  admin_add_equip_btn_back: "Back",
  admin_add_equip_btn_save: "Save",
  admin_add_equip_btn_add_photo_before: "Add Photo Before",
  admin_add_equip_btn_add_photo_after: "Add Photo After",
  admin_add_equip_btn_send_laudo: "Send Report (PDF)",
  admin_add_equip_btn_close: "Close",
  admin_add_equip_card_title_data: "📌 Equipment Data",
  admin_add_equip_card_title_photos: "📷 Photos",
  admin_add_equip_card_title_laudos: "📑 Reports",
  admin_details_error_no_quotation: "No quotation selected",
  admin_details_error_loading_details: "Error loading details. Using demo data.",
  admin_details_not_informed_company: "Company not informed",
  admin_details_not_informed_client: "Client not informed",
  admin_details_not_informed_address: "Address not informed",
  admin_details_not_specified_service: "Service not specified",
  admin_details_no_observations: "No observations",
  admin_details_status_received_analysis: "Equipment received and under analysis.",
  admin_details_swal_confirm_receive_title: "Confirm receipt?",
  admin_details_swal_confirm_receive_text: "This signals the client of receipt and indicates that the equipment will be analyzed.",
  admin_details_swal_confirm_button: "Yes, confirm",
  admin_details_swal_cancel_button: "Cancel",
  admin_details_swal_success_title: "Success",
  admin_details_swal_update_success_text: "Estimate updated to 'equipment under analysis'.",
  admin_details_swal_error_title: "Error",
  admin_details_swal_update_error_text: "Could not update estimate.",
  admin_details_loading_text: "Loading details...",
  admin_details_card_title_client: "📌 CLIENT DATA",
  admin_details_card_title_estimate: "📋 ESTIMATE DATA",
  admin_details_card_title_budget: "💰 BUDGET DATA",
  admin_details_no_data_available: "No data available for display.",
  admin_equip_details_error_id_not_found: "Equipment ID not found",
  admin_equip_details_loading_text: "Loading...",
  admin_equip_details_error_not_found: "Equipment not found",
  admin_equip_details_title_item_data: "Item Data",
  admin_equip_details_title_latest_photos: "Latest Equipment Photos",
  admin_equip_details_title_revision_history: "Revision History",
  admin_equipaments_title_my_equipments: "My Equipment",
  admin_equipaments_btn_add_equipment: "Add Equipment",
  admin_estimate_respond_swal_attention_title: "Attention",
  admin_estimate_respond_swal_no_items_text: "Add at least one item to the response",
  admin_estimate_respond_swal_success_title: "Success",
  admin_estimate_respond_swal_sent_text: "Response sent!",
  admin_estimate_respond_swal_error_title: "Error",
  admin_estimate_respond_swal_error_text: "Could not send response",
  admin_estimate_respond_created_by_admin: "created by: Commercial",
  admin_estimate_respond_card_title_client: "📌 CLIENT DATA",
  admin_estimate_respond_card_title_estimate: "📋 ESTIMATE DATA",
  admin_estimate_respond_card_title_admin_response: "✍️ COMMERCIAL RESPONSE",
  admin_home_error_loading_details: "Error loading data. Using demo data.",
  admin_home_swal_search_title: "Search Equipment",
  admin_home_swal_search_label: "Enter equipment ID:",
  admin_home_swal_search_btn_confirm: "Search",
  admin_home_swal_search_btn_cancel: "Cancel",
  admin_home_swal_found_title: "Equipment Found",
  admin_home_swal_not_found_title: "Equipment not located",
  admin_home_card_label_waiting_estimate: "Waiting\nEstimate",
  admin_home_card_label_estimate_delivered: "Estimate\nDelivered",
  admin_home_card_label_waiting_equipment: "Waiting\nEquipment",
  admin_home_card_label_equipment_analysis: "Equipment\nUnder Analysis",
  admin_home_card_label_waiting_budget: "Waiting\nBudget",
  admin_home_card_label_pending_approval: "Pending\nApproval",
  admin_home_card_label_approved_maintenance: "Approved for\nMaintenance",
  admin_home_card_label_waiting_inspection: "Waiting\nInspection and Report",
  admin_home_card_label_waiting_nf: "Waiting\nBilling",
  admin_home_card_label_ready_pickup: "Ready for\nPickup",
  admin_home_loading_text: "Loading data...",
  admin_home_status_desc_waiting_estimate: "The client requested an estimate.",
  admin_home_status_desc_estimate_delivered: "The estimate was answered, the client should receive it soon.",
  admin_home_status_desc_waiting_equipment: "The client accepted the estimate, and we are waiting for the equipment to be sent.",
  admin_home_status_desc_equipment_analysis: "The equipment has arrived and is under analysis/registration.",
  admin_home_status_desc_waiting_budget: "The analysis was performed, waiting for admin release.",
  admin_home_status_desc_pending_approval: "The client has not yet approved the budget.",
  admin_home_status_desc_approved_maintenance: "The client approved and should have sent the purchase order.",
  admin_home_status_desc_waiting_inspection: "Perform the final inspection and upload the equipment report.",
  admin_home_status_desc_waiting_nf: "Process the client's billing.",
  admin_home_status_desc_ready_pickup: "The equipment is ready, waiting for the client to pick up to close.",
  admin_home_last_update_text: "Last update: ",
  admin_home_table_header_created: "Created",
  admin_home_table_header_type: "Type",
  admin_home_table_header_code: "Code",
  admin_home_table_header_cnpj: "CNPJ",
  admin_home_table_header_client: "Client",
  admin_home_table_header_value: "Value $",
  admin_home_table_footer_total: "TOTAL",
  admin_home_btn_register: "Register",
  admin_home_btn_register_client: "Register Client",
  admin_home_btn_search: "Search",
  admin_home_search_cnpj_nota_label: "Search by CNPJ or invoice number",
  admin_home_search_cnpj_nota_placeholder: "Type the CNPJ or invoice number",
  admin_home_search_note_pending_msg: "CNPJ search is active. Invoice search will be enabled after backend update on Home.",
  admin_home_btn_search_equipment: "Search Equipment",
  admin_home_btn_clients: "Clients",
  admin_home_btn_reports: "Reports",
  admin_home_panel_title_phases: "Operation Phases",
  admin_home_panel_label_responsible: "Responsible:",
  admin_home_panel_label_admin: "Commercial",
  admin_home_panel_label_client: "Client",
  admin_home_panel_label_workshop: "Workshop",
  admin_quotations_swal_attention_title: "Attention",
  admin_quotations_swal_new_appointment_warning: "By proceeding, you will generate a new appointment without a link to any estimate. Are you sure you want to continue? (To generate a linked appointment, do so from the estimate details)",
  admin_quotations_swal_confirm_continue: "Yes, continue",
  admin_quotations_swal_cancel: "Cancel",
  admin_quotations_swal_new_appointment_title: "New Appointment",
  admin_quotations_swal_creating_appointment_text: "Creating new appointment...",
  admin_quotations_loading_text: "Loading...",
  admin_quotations_page_title: "Quotations",
  admin_quotations_label_client: "Client: ",
  admin_quotations_btn_create_appointment: "Create Appointment",
  admin_quotations_btn_equipments: "Equipment",
  admin_quotations_section_title_pending: "Pending with Me",
  admin_quotations_empty_message_pending: "No pending records",
  admin_quotations_section_title_in_progress: "In Progress",
  admin_quotations_empty_message_in_progress: "No records in progress",
  admin_quotations_section_title_finished: "Finished",
  admin_quotations_empty_message_finished: "No finished records",
  admin_quote_swal_attention_title: "Attention",
  admin_quote_swal_equipment_already_added: "Equipment already added to the budget",
  admin_quote_swal_remove_equipment_title: "Remove equipment?",
  admin_quote_swal_yes: "Yes",
  admin_quote_swal_no: "No",
  admin_quote_swal_no_service_linked: "This equipment does not have a linked service",
  admin_quote_swal_error_title: "Error",
  admin_quote_swal_service_not_found: "Service not found",
  admin_quote_swal_remove_item_title: "Remove item?",
  admin_quote_swal_success_title: "Success",
  admin_quote_swal_attachment_sent: "Attachment sent successfully!",
  admin_quote_swal_add_nf_title: "Add Invoice",
  admin_quote_swal_nf_name_placeholder: "Invoice name",
  admin_quote_swal_select_file: "Select File",
  admin_quote_swal_cancel: "Cancel",
  admin_quote_swal_validation_nf: "Fill in the invoice name and date",
  admin_quote_swal_nf_sent: "Invoice sent!",
  admin_quote_swal_remove_attachment_title: "Remove attachment?",
  admin_quote_swal_action_undone_text: "This action cannot be undone.",
  admin_quote_swal_confirm_remove: "Yes, remove",
  admin_quote_swal_attachment_removed: "Attachment removed successfully",
  admin_quote_swal_remove_nf_title: "Remove Invoice?",
  admin_quote_swal_nf_removed: "Invoice removed successfully",
  admin_quote_swal_no_equipments_error: "Add at least one equipment to the budget",
  admin_quote_swal_generate_quote_title: "Generate Budget",
  admin_quote_swal_generate_quote_text: "This will generate a budget for administrative approval.\n\nBe sure to have included all parts and procedures of the service.\n\nDo you want to proceed?",
  admin_quote_swal_generate_quote_confirm: "Yes, generate budget",
  admin_quote_swal_quote_saved_success: "Budget saved successfully!",
  admin_quote_swal_save_error: "Could not save the budget",
  admin_search_placeholder_company_cnpj: "company or cnpj",
  admin_search_placeholder_quotation_num: "quotation no.",
  admin_search_msg_initial: "🔎 Enter what you want to seek",
  admin_search_title_companies_found: "Companies Found",
  admin_search_msg_no_companies: "No companies found",
  admin_search_title_quotations_found: "Quotations Found",
  admin_search_msg_no_quotations: "No quotations found",
  admin_search_label_company: "Company:",
  admin_search_label_email: "Email:",
  admin_search_label_phone: "Phone:",
  admin_search_label_cnpj: "CNPJ:",
  admin_search_label_doc_num: "Doc No.:",
  admin_search_label_type: "Type:",
  admin_search_label_date: "Date:",
  admin_search_btn_view_equipments: "View Equipment",
  admin_search_btn_view: "View",
  admin_shipment_title_main: "📦 Shipping Instructions",
  admin_shipment_title_order_data: "Order Data",
  admin_shipment_title_sender: "Sender",
  admin_shipment_title_shipping_address: "Shipping Address",
  admin_shipment_title_general_instructions: "General Instructions",
  admin_shipment_msg_important_print: "Important: Print this document and attach it with the equipment. If you cannot print, write the order number and your CNPJ on the packaging visibly.",
  admin_shipment_label_estimate_num: "Estimate No.: ",
  admin_shipment_label_cnpj: "CNPJ: ",
  admin_shipment_label_client: "Client:",
  admin_shipment_label_company: "Company:",
  admin_shipment_label_phone: "Phone:",
  admin_shipment_label_email: "E-mail:",
  admin_shipment_address_company_name: "Bepi Service",
  admin_shipment_address_street: "Estrada Velha Guarulhos São Miguel, 5135",
  admin_shipment_address_city_zip: "Jardim Arapongas, Guarulhos - SP, 07210-250",
  admin_shipment_instruction_1: "Pack the equipment safely to avoid damage.",
  admin_shipment_instruction_2: "Include all mandatory accessories for the requested service.",
  admin_shipment_instruction_3: "Identify each item if there is more than one per pack.",
  admin_shipment_instruction_4: "Send only approved equipment. Rejected ones should not be shipped.",
  admin_shipment_instruction_5: "We do not charge for collection. Shipping is at the client's expense.",
  admin_shipment_instruction_6: "Shipping invoice must be correct. In case of error, the return will be via FOB freight.",
  admin_shipment_msg_warning_nf: "⚠️ If the invoice is issued incorrectly, the equipment will be returned by FOB freight.",
  admin_shipment_msg_warning_missing_data: "💡 Missing the order number or CNPJ may delay the start of your service.",
  admin_shipment_footer_technical_service: "BEPI SERVICE - Technical support",
  admin_shipment_footer_whatsapp: "If you have questions, contact us via WhatsApp: (11) 91234-5678",
  admin_shipment_btn_back_home: "Back to Home",
  admin_shipment_btn_print: "Print Instructions",
  admin_breadcrumb_quotations: "Quotations",
  admin_breadcrumb_quote: "Budget",
  admin_breadcrumb_estimate_respond: "Estimate Response",
  admin_breadcrumb_search: "Search",
  admin_breadcrumb_add_equipment: "Add Equipment",
  admin_breadcrumb_shipment: "Shipping Instructions",
  admin_home_card_label_sent: "Sent",
  admin_home_status_desc_sent: "The material has been sent and is no longer in the workshop waiting for pickup. Process closed.",
  admin_home_table_header_actions: "Actions",
  admin_home_mark_sent_btn: "Mark as Sent",
  admin_home_mark_sent_confirm_title: "Confirm",
  admin_home_mark_sent_confirm_text: "Do you want to move this item to Sent?",
  admin_home_mark_sent_success: "Status updated to Sent.",
  admin_home_mark_sent_error: "Could not update status to Sent.",
  admin_home_card_label_authorize_maintenance: "Authorize\nMaintenance",
  admin_home_status_desc_authorize_maintenance: "Validate whether the client has sent all information required to start the maintenance.",
  admin_home_authorize_maintenance_btn: "Authorize Maintenance",
  admin_home_authorize_maintenance_confirm_title: "Confirm",
  admin_home_authorize_maintenance_confirm_text: "Do you want to move this item to Authorize Maintenance?",
  admin_home_authorize_maintenance_success: "Status updated to Authorize Maintenance.",
  admin_home_authorize_maintenance_error: "Could not update status to Authorize Maintenance.",
  admin_home_approve_maintenance_btn: "Approve for Maintenance",
  admin_home_approve_maintenance_confirm_title: "Confirm",
  admin_home_approve_maintenance_confirm_text: "Do you want to move this item to Approved for Maintenance?",
  admin_home_approve_maintenance_success: "Status updated to Approved for Maintenance.",
  admin_home_approve_maintenance_error: "Could not update status to Approved for Maintenance.",
  admin_home_card_label_finalized: "Finalized",
  admin_home_status_desc_finalized: "Flow finalized manually by the commercial team.",
  admin_details_finalize_flow_btn: "Finalize Operation",
  admin_details_finalize_flow_confirm_title: "Confirm",
  admin_details_finalize_flow_confirm_text: "Do you want to finalize the flow for this quotation?",
  admin_details_finalize_flow_success: "Flow finalized successfully.",
  admin_details_finalize_flow_error: "Could not finalize the flow.",
}
